<div class="stat-card">
  <div class="stat-card__icon" [style.background-color]="iconBgColor">
    <app-feather-icons *ngIf="iconType === 'feather'" [icon]="icon" [class]="'icon'"></app-feather-icons>
    <mat-icon *ngIf="iconType === 'material'">{{ icon }}</mat-icon>
    <i *ngIf="iconType === 'fa'" [class]="icon"></i>
  </div>
  
  <div class="stat-card__content">
    <div class="stat-card__header">
      <span class="stat-card__label">{{ label }}</span>
      <span class="stat-card__arrow" *ngIf="showArrow">↗</span>
    </div>
    <div class="stat-card__value">{{ value }}</div>
    <div class="stat-card__subtitle">{{ subtitle }}</div>
  </div>
</div>